'use strict';
window.uomedia = window.uomedia || {};
var Cookies = Cookies || null;
window.uomedia.agree = Cookies ? Cookies.get('agree') : false;

(($) => {
  // force download attribute on each btn
  $('.download-body a').each(function () {
    $(this).attr('download', true);
  });

  // add modals to body instead of deep within markup
  $(document).on('show.bs.modal', '.modal', function () {
    $(this).appendTo('body');
  });

  // disabled by default on load
  if (window.uomedia.agree === 'false') {
    $('.download-body a').addClass('disabled');
  } else {
    $('.modal input[type="checkbox"]').prop('checked', 'true');
  }

  $('.download-body a').on('click', function (event) {
    if ($(this).hasClass('disabled') || window.uomedia.agree === 'false') {
      event.preventDefault();
    } else {
      // close modal window
      $('.modal').modal('hide');
    }
  });


  $('.modal input[type="checkbox"]').on('change', function (e) {
    // 24 hr cookie
    const agreeValue = $(this).prop('checked');
    window.uomedia.agree = agreeValue;
    if (Cookies) {
      Cookies.set('agree', agreeValue, { expires: 1 });
    }
    $('.download-body a').toggleClass('disabled');
  });

})(jQuery);
